(ns common.modal.util
  (:require [re-frame.core :as rf]))

;; TODO: Consider https://github.com/jonatanklosko/material-ui-confirm/

(defn with-confirmation-modal
  "When `showing-condition` is truthy, `action-fn` is invoked after the user goes through a confirmation modal and accept it.
   When `showing-condition` is falsy, `action-fn` is invoked immediately."
  [showing-condition modal-id modal-props action-fn]
  (if showing-condition
    (rf/dispatch [:modal/open {:id modal-id
                               :props (assoc modal-props
                                             :on-submit action-fn)}])
    (action-fn)))
